import { render, staticRenderFns } from "./AvatarEditor.vue?vue&type=template&id=13e454cf"
import script from "./AvatarEditor.vue?vue&type=script&lang=js"
export * from "./AvatarEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports